import JoinDetailsAction from '../actions/joinDetails';

const initialState = {
    propertyName: '',
    latinPropertyName: '',
    propertyType: 'Select',
    currency: 'Select',
    unitCount: '',
    managerInfo: null,
    chainInfo: null,
    propertyNameValidation: { isValid: false },
    latinPropertyNameValidation: { isValid: false },
    propertyTypeValidation: { isValid: false },
    unitCountValidation: { isValid: false },
    currencyValidation: { isValid: false },
    currencyList: {
        values: [],
        start: false,
        success: false,
        fail: false
    },
    competitorUrl: '',
    competitorUrlLoading: false,
    websiteUrl: '',
    websiteUrlValidation: { isValid: true },
    submarketId: '',
    isSelfServe: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
    case JoinDetailsAction.SET_IS_SELF_SERVE:
        return {
            ...state,
            isSelfServe: action.isSelfServe
        };
    case JoinDetailsAction.SET_SUBMARKET_ID:
        return {
            ...state,
            submarketId: action.submarketId
        };
    case JoinDetailsAction.SET_WEBSITE_URL:
        return { ...state, websiteUrl: action.websiteUrl };
    case JoinDetailsAction.SET_WEBSITE_URL_VALIDATION:
        return { ...state, websiteUrlValidation: action.result };
    case JoinDetailsAction.SET_COMPETITOR_LINK:
        return { ...state, competitorUrl: action.competitorUrl };
    case JoinDetailsAction.SET_COMPETITOR_LINK_LOADING:
        return { ...state, competitorUrlLoading: action.competitorUrlLoading };
    case JoinDetailsAction.SET_PROPERTY_NAME:
        return { ...state, propertyName: action.propertyName };
    case JoinDetailsAction.SET_PROPERTY_NAME_VALIDATION:
        return { ...state, propertyNameValidation: action.result };
    case JoinDetailsAction.SET_LATIN_PROPERTY_NAME:
        return { ...state, latinPropertyName: action.latinPropertyName };
    case JoinDetailsAction.SET_LATIN_PROPERTY_NAME_VALIDATION:
        return { ...state, latinPropertyNameValidation: action.result };
    case JoinDetailsAction.SET_PROPERTY_TYPE:
        return { ...state, propertyType: action.propertyType };
    case JoinDetailsAction.SET_PROPERTY_TYPE_VALIDATION:
        return { ...state, propertyTypeValidation: action.result };
    case JoinDetailsAction.RESET_PROPERTY_TYPE:
        return {
            ...state,
            propertyType: initialState.propertyType,
            propertyTypeValidation: initialState.propertyTypeValidation
        };
    case JoinDetailsAction.SET_CURRENCY_CODE:
        return { ...state, currency: action.currency };
    case JoinDetailsAction.SET_CURRENCY_VALIDATION:
        return { ...state, currencyValidation: action.result };
    case JoinDetailsAction.SET_UNIT_COUNT:
        return { ...state, unitCount: action.unitCount };
    case JoinDetailsAction.SET_UNIT_COUNT_VALIDATION:
        return { ...state, unitCountValidation: action.result };
    case JoinDetailsAction.SET_LODGING_PREFERENCE:
        return { ...state, lodgingPreference: action.lodgingPreference };
    case JoinDetailsAction.SET_MANAGER_INFO:
        return { ...state, managerInfo: action.managerInfo };
    case JoinDetailsAction.SET_CHAIN_INFO:
        return { ...state, chainInfo: action.chainInfo };
    case JoinDetailsAction.FETCH_CURRENCY_START:
        return {
            ...state,
            currencyList: {
                values: [],
                start: true,
                success: false,
                fail: false
            }
        };
    case JoinDetailsAction.FETCH_CURRENCY_FAIL:
        return {
            ...state,
            currencyList: {
                values: [],
                start: false,
                success: false,
                fail: true
            }
        };
    case JoinDetailsAction.FETCH_CURRENCY_SUCCESS:
        return {
            ...state,
            currencyList: {
                values: action.currencyList,
                start: false,
                success: true,
                fail: false
            }
        };
    default:
        return state;
    }
};
